import React from 'react';
import { View, StyleSheet, ScrollView, SafeAreaView } from 'react-native';
import { Button, Card, Title, Paragraph, useTheme, Text } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { useFocusEffect } from '@react-navigation/native';

const VisitsHubScreen = ({ navigation }) => {
  const theme = useTheme();

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        
        {/* Aktif Ziyaretler */}
        <Card 
          style={styles.card} 
          mode="elevated" 
          onPress={() => navigation.navigate('ActiveVisits')}
        >
          <Card.Content style={styles.cardContent}>
            <View style={styles.iconContainer}>
              <MaterialCommunityIcons 
                name="heart-pulse" 
                size={40} 
                color="rgb(125, 76, 236)" 
              />
            </View>
            <View style={styles.textContainer}>
              <Title>Aktif Ziyaretler</Title>
              <Paragraph>
                Devam eden park ziyaretleri
              </Paragraph>
            </View>
            <MaterialCommunityIcons 
              name="chevron-right" 
              size={30} 
              color="rgb(125, 76, 236)" 
            />
          </Card.Content>
        </Card>
        
        {/* Onay Bekleyen Ziyaretler */}
        <Card 
          style={styles.card} 
          mode="elevated" 
          onPress={() => navigation.navigate('PendingVisits')}
        >
          <Card.Content style={styles.cardContent}>
            <View style={[styles.iconContainer, {backgroundColor: 'rgba(125, 76, 236, 0.15)'}]}>
              <MaterialCommunityIcons 
                name="clock-time-four" 
                size={40} 
                color="rgb(125, 76, 236)" 
              />
            </View>
            <View style={styles.textContainer}>
              <Title>Onay Bekleyen Ziyaretler</Title>
              <Paragraph>
                Onay bekleyen ziyaret talepleri
              </Paragraph>
            </View>
            <MaterialCommunityIcons 
              name="chevron-right" 
              size={30} 
              color="rgb(125, 76, 236)" 
            />
          </Card.Content>
        </Card>
        
        {/* Ziyaret Geçmişi */}
        <Card 
          style={styles.card} 
          mode="elevated" 
          onPress={() => navigation.navigate('VisitHistory')}
        >
          <Card.Content style={styles.cardContent}>
            <View style={[styles.iconContainer, {backgroundColor: 'rgba(125, 76, 236, 0.15)'}]}>
              <MaterialCommunityIcons 
                name="history" 
                size={40} 
                color="rgb(125, 76, 236)" 
              />
            </View>
            <View style={styles.textContainer}>
              <Title>Ziyaret Geçmişi</Title>
              <Paragraph>
                Tamamlanmış ziyaretler ve ödemeler
              </Paragraph>
            </View>
            <MaterialCommunityIcons 
              name="chevron-right" 
              size={30} 
              color="rgb(125, 76, 236)" 
            />
          </Card.Content>
        </Card>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  scrollContent: {
    padding: 16,
    paddingTop: 24,
  },
  screenTitle: {
    fontSize: 26,
    fontWeight: 'bold',
    marginBottom: 24,
    textAlign: 'center',
    color: 'rgb(125, 76, 236)',
  },
  card: {
    marginBottom: 16,
    borderRadius: 12,
    elevation: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
  },
  iconContainer: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: 'rgba(125, 76, 236, 0.15)',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  textContainer: {
    flex: 1,
  },
});

export default VisitsHubScreen;
